import { createContext, useState } from 'react';

export const contextTheme = createContext();

const ProviderTheme = ({ children}) => {
     const [theme, setTheme] = useState(false);

     const toggleTheme = () => {
         setTheme(!theme);
     }
    return(
        <contextTheme.Provider value={{theme, toggleTheme}}>
            { children }
        </contextTheme.Provider>
    )
}

export default ProviderTheme;